const ROUTES = {
    HOME: "/",
    THANKS: "/thanks",
    POLICY: "/policy/",
    TERMS: "/terms/",
    CLASS: "/tatiflix/",
    ABOUT: "/about/",
    CONTACT: "/contact/",
    SERVICES: "/services/",
}

export default ROUTES;